export const LAYERS_REDUCER_NAMES = {
  MAP_ENTITIES: 'mapEntities',
  STATE: 'state',
};
